<div
  class="zwrapper trades-container flex flex-row py-2 items-center overflow-x-auto m-auto dark-scrollbar"
>
  @if (trades$ | async; as trades) { @for (trade of trades; track trade) {
  <mat-card class="item mx-2" appearance="outlined" style="font-size: 13px">
    <mat-card-header style="white-space: nowrap; display: inline-block">
      <mat-card-title
        ><span class="text-base">Traded At -</span>
        <span class="text-gray-400" style="font-size: 11px">{{
          trade.createdAt | date : "MMM d, y, h:mm a"
        }}</span></mat-card-title
      >
    </mat-card-header>
    <mat-card-content class="">
      <div class="flex flex-row justify-between items-center gap-8">
        <span
          >{{ trade.commodity }} @if(trade.product_type){ -
          {{ trade.product_type }}
          } - {{ trade.grade }}</span
        >
        <span
          >{{ trade.currency }} $ {{ trade.price | priceType }}/
          {{ trade.price_units }}&nbsp;({{ trade.delivery_type }})
        </span>
      </div>
      <div class="flex flex-row justify-between items-center gap-8">
        <span>{{ trade.destination }}</span>
        <span>{{ trade.volume_value }} {{ trade.units }}</span>
      </div>
      <div
        class="flex flex-row justify-start items-center gap-8 text-sm text-gray-400"
        style="font-size: 11px"
      >
        <span>
          {{ trade.ship_begin | date : "MMM d, y" }} -
          {{ trade.ship_end | date : "MMM d, y" }}
        </span>
      </div>
    </mat-card-content>
  </mat-card>
  } }
</div>
